import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  addManualAuthorization,
  deleteManualAuthorization,
  getManualAuthorization,
} from "../../redux/actions/misc/manual_authorization_action";
import DeleteButton from "../../common/buttons/DeleteButton";
import PageTitle from "../../common/shared/PageTitle";
import ConferenceIcon from "../../common/icons/ConferenceIcon";
import Loader from "../../common/loaders/Loader";
import {
  Button,
  Card,
  CardBody,
  Dialog,
  DialogBody,
  DialogFooter,
  DialogHeader,
  Typography,
} from "@material-tailwind/react";
import { DataGrid } from "@mui/x-data-grid";
import AlertMessage from "../../common/actions/AlertMessage";
import InputText from "../../common/forms/InputText";

const ManualAuthList = () => {
  const { id } = useParams();

  const [loading, setLoading] = useState(false);
  const [actionLoading, setActionLoading] = useState(false);

  const [manualType, setManualType] = useState("");
  const [formData, setFormData] = useState("");

  const [openDialog, setOpenDialog] = useState(false);
  const [confirmDialog, setConfirmDialog] = useState(false);

  const [listManual, setListManual] = useState([]);
  const [confirmData, setConfirmData] = useState({});

  const dispatch = useDispatch();

  const { dataError, data, genre } = useSelector((state) => state.manualAuth);
  const userData = useSelector((state) => state.auth?.userData);

  const handleManualModal = (value) => {
    setManualType(value);
    setOpenDialog((prev) => !prev);
  };

  const handleConfirmModal = (value) => {
    setConfirmData(value);
    setConfirmDialog((prev) => !prev);
  };

  const updateFormValue = ({ value }) => {
    setFormData({ [manualType]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const data = { type: id, ...formData };
    await dispatch(addManualAuthorization(data)).finally(() => {
      setLoading(false);
    });
  };

  const handleDelete = async () => {
    setActionLoading(true);
    await dispatch(deleteManualAuthorization(confirmData.row.id)).finally(
      () => {
        window.location.reload();
        setActionLoading(false);
      }
    );
  };

  const columns = [
    {
      field: "arrayIndex",
      headerName: "ID",
      width: 80,
      valueFormatter: (params) => (params.value + 1).toString(),
    },
    { field: "name", headerName: "Name", flex: 1 },
    { field: "type", headerName: "Type", width: 120 },
    {
      field: "actions",
      headerName: "Actions",
      width: 100,
      renderCell: (params) =>
        userData.role_id === 3 && (
          <DeleteButton onClick={() => handleConfirmModal(params)} />
        ),
    },
  ];

  useEffect(() => {
    dispatch(getManualAuthorization(id));
  }, [dispatch, id]);

  useEffect(() => {
    if (Array.isArray(data)) {
      setListManual(data);
    } else {
      setListManual([]);
    }
  }, [data]);

  return (
    <>
      <div className="flex justify-between p-4">
        <div className="flex flex-col items-start">
          <PageTitle
            title={`${id.toUpperCase()} Manual Authorization`}
            icon={<ConferenceIcon />}
          />
          <span className="italic capitalize">*{genre}</span>
        </div>

        {userData.role_id === 3 && (
          <div className="flex items-center gap-4">
            {id !== "chamber" && (
              <Button onClick={() => handleManualModal("bar_number")}>
                Add Lawyer
              </Button>
            )}
            <Button
              variant="outlined"
              onClick={() => handleManualModal("chamber")}
            >
              Add Chamber
            </Button>
          </div>
        )}
      </div>

      {openDialog && (
        <Dialog open={openDialog} handler={handleManualModal} size={"xs"}>
          <DialogHeader>Manual Authorization</DialogHeader>
          <DialogBody>
            {dataError && <AlertMessage type={"error"} message={dataError} />}

            <Typography variant="h6" className="mb-3" color="black">
              {manualType === "bar_number"
                ? "Enter Bar Number"
                : manualType === "chamber"
                ? "Enter Chamber #"
                : ""}
            </Typography>
            <InputText
              type="text"
              defaultValue=""
              updateType={manualType}
              labelTitle={manualType}
              updateFormValue={updateFormValue}
              required={true}
            />
          </DialogBody>
          <DialogFooter>
            <Button
              variant="text"
              color="red"
              onClick={() => setOpenDialog((prev) => !prev)}
              className="mr-1"
            >
              <span>Cancel</span>
            </Button>
            <Button onClick={(e) => handleSubmit(e)}>
              <span>Submit</span>
            </Button>
          </DialogFooter>
        </Dialog>
      )}

      {confirmDialog && (
        <Dialog open={confirmDialog} handler={handleConfirmModal} size="xs">
          <DialogHeader>Confirm Deletion</DialogHeader>
          <DialogBody>
            <Typography variant="paragraph" color="black">
              Please confirm the deletion of:{" "}
              <span className="font-bold">{confirmData.row.name}</span>
            </Typography>
          </DialogBody>
          <DialogFooter>
            <Button
              variant="text"
              color="red"
              onClick={() => setConfirmDialog((prev) => !prev)}
              className="mr-1"
            >
              <span>Cancel</span>
            </Button>
            <Button onClick={() => handleDelete(confirmData.row.id)}>
              <span>Submit</span>
            </Button>
          </DialogFooter>
        </Dialog>
      )}

      {loading ? (
        <Loader />
      ) : (
        <Card className="w-full p-6 shadow-xl mb-20">
          <CardBody>
            <DataGrid
              sx={{ border: 0 }}
              rows={listManual.map((row, index) => {
                return { ...row, arrayIndex: index };
              })}
              columns={columns}
            />
          </CardBody>
        </Card>
      )}
    </>
  );
};

export default ManualAuthList;
